export default "__VITE_ASSET__502ea5a9__"